module.exports = __webpack_public_path__ + "static/media/background_8.9fa44b37.png";